import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener('click', () => this.updateTargets());
    this.updateTargets();
  }

  updateTargets() {
    document.querySelectorAll(this.element.dataset.targets).forEach(($el) => {
      let valueTarget = this.element.dataset.hiddeOn || 'false';
      $el.classList.toggle('hidden', this.element.checked.toString() === valueTarget);
    });
  }
};